import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { delayvyed5wvki0ic as delay } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionConnectionException12fjxvnnqzby5 as SubscriptionConnectionException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from '../../../../../../../kotlinx-atomicfu/kotlinx/atomicfu/locks/Synchronized.mjs';
import { Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ConnectionKeepAliveServerMessage_instance2ucdc3b7nis36 as ConnectionKeepAliveServerMessage_instance,
  PongServerMessage_instancegdhl9dh77vj7 as PongServerMessage_instance,
  PingServerMessage_instance2x2b9b7bh91v2 as PingServerMessage_instance,
  ParseErrorServerMessage28gxznaow3b26 as ParseErrorServerMessage,
  OperationErrorServerMessage3f3enfqsilvrv as OperationErrorServerMessage,
  CompleteServerMessage1c62v9ocjho2f as CompleteServerMessage,
  ResponseServerMessage1aifb0dqdz3sq as ResponseServerMessage,
  ConnectionErrorServerMessage21355wd69v8tf as ConnectionErrorServerMessage,
  ConnectionAckServerMessage_instance2uyrftb08sig4 as ConnectionAckServerMessage_instance,
} from '../ServerMessage.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  DataClientMessage3splhk6u8gldd as DataClientMessage,
  TextClientMessage15942w7lyj1yt as TextClientMessage,
} from '../ClientMessage.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function restartIdleTimeout($this) {
  var tmp0_safe_receiver = $this.s67_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.mx();
  }
  var tmp = $this;
  tmp.s67_1 = launch($this.r67_1, VOID, VOID, SubscribableWebSocket$restartIdleTimeout$slambda($this));
}
function shutdownInternal($this, cause) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listeners = ArrayList().p2();
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.q67_1;
  if ($this.u67_1.equals(SocketState_ShutDown_getInstance())) {
    return Unit_instance;
  }
  $this.u67_1 = SocketState_ShutDown_getInstance();
  cancel($this.r67_1);
  $this.v67_1 = cause;
  listeners.u2($this.w67_1.w4());
  $this.w67_1.a5();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = listeners.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.i68(cause);
  }
}
function SubscribableWebSocket$restartIdleTimeout$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(this$0.p67_1, $completion);
    this$0.n68(ApolloNetworkException().b47('WebSocket is idle'), 1001, 'Idle');
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onOpen$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.y67_1, yield* this$0.m67_1.i66($completion));
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onOpen$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(this$0.o67_1, $completion);
    this$0.n68(ApolloNetworkException().b47('Timeout while waiting for connection_ack'), 1001, 'Timeout while waiting for connection_ack');
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onMessage$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    while (true) {
      yield* delay(this$0.n67_1, $completion);
      var tmp0_safe_receiver = this$0.m67_1.l66();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        send(this$0.y67_1, tmp0_safe_receiver);
      }
    }
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onMessage$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this$0.x67_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      send(this$0.y67_1, yield* this$0.m67_1.j66(element, $completion));
    }
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$startOperation$slambda(this$0, $request) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.y67_1, yield* this$0.m67_1.j66($request, $completion));
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$stopOperation$slambda(this$0, $request) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.y67_1, this$0.m67_1.k66($request));
    return Unit_instance;
  }, 1);
}
var SubscribableWebSocketClass;
function SubscribableWebSocket() {
  if (SubscribableWebSocketClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, httpHeaders, wsProtocol, pingInterval, connectionAcknowledgeTimeout, idleTimeout) {
        this.m67_1 = wsProtocol;
        this.n67_1 = pingInterval;
        this.o67_1 = connectionAcknowledgeTimeout;
        this.p67_1 = idleTimeout;
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.q67_1 = get_atomicfu$reentrantLock();
        this.r67_1 = CoroutineScope(Dispatchers_getInstance().g13_1);
        this.s67_1 = null;
        this.t67_1 = null;
        this.u67_1 = SocketState_AwaitOpen_getInstance();
        this.v67_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.w67_1 = LinkedHashMap().ec();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.x67_1 = ArrayList().p2();
        var tmp_2;
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(httpHeaders, Collection())) {
            tmp_3 = httpHeaders.n1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = httpHeaders.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            if (element.t48_1.toLowerCase() === 'sec-websocket-protocol') {
              tmp$ret$3 = true;
              break $l$block_0;
            }
          }
          tmp$ret$3 = false;
        }
        if (tmp$ret$3) {
          tmp_2 = httpHeaders;
        } else {
          tmp_2 = plus(httpHeaders, new (HttpHeader())('Sec-WebSocket-Protocol', this.m67_1.h1()));
        }
        var headers = tmp_2;
        this.y67_1 = webSocketEngine.o68(serverUrl, headers, this);
      }
      p68(markActive) {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.q67_1;
        // Inline function 'kotlin.also' call
        var this_0 = this.u67_1.equals(SocketState_ShutDown_getInstance());
        if (!this_0 && markActive) {
          var tmp0_safe_receiver = this.s67_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.mx();
          }
          this.s67_1 = null;
        }
        return this_0;
      }
      n68(cause, code, reason) {
        shutdownInternal(this, cause);
        this.y67_1.q68(code, reason);
      }
      r68() {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.q67_1;
        if (this.u67_1.w1_1 === 0) {
          launch(this.r67_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda(this));
          var tmp = this;
          tmp.t67_1 = launch(this.r67_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda_0(this));
          this.u67_1 = SocketState_AwaitAck_getInstance();
        }
      }
      s68(text) {
        var message = this.m67_1.n66(text);
        if (equals(message, ConnectionAckServerMessage_instance)) {
          var tmp0_safe_receiver = this.t67_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.mx();
          }
          this.t67_1 = null;
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.q67_1;
          if (!this.u67_1.equals(SocketState_AwaitAck_getInstance())) {
            return Unit_instance;
          }
          this.u67_1 = SocketState_Connected_getInstance();
          var tmp = this.n67_1;
          if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
            launch(this.r67_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda(this));
          }
          launch(this.r67_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda_0(this));
        } else {
          if (message instanceof ConnectionErrorServerMessage()) {
            this.n68(SubscriptionConnectionException().r4e(message.t68_1), 1001, 'Connection error');
          } else {
            if (message instanceof ResponseServerMessage()) {
              // Inline function 'kotlinx.atomicfu.locks.withLock' call
              this.q67_1;
              var tmp1_safe_receiver = this.w67_1.u4(message.o66_1);
              if (tmp1_safe_receiver == null)
                null;
              else {
                tmp1_safe_receiver.e68(message.p66_1);
              }
            } else {
              if (message instanceof CompleteServerMessage()) {
                // Inline function 'kotlinx.atomicfu.locks.withLock' call
                this.q67_1;
                var tmp2_safe_receiver = this.w67_1.u4(message.q66_1);
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  tmp2_safe_receiver.g68();
                }
              } else {
                if (message instanceof OperationErrorServerMessage()) {
                  // Inline function 'kotlinx.atomicfu.locks.withLock' call
                  this.q67_1;
                  var tmp3_safe_receiver = this.w67_1.u4(message.r66_1);
                  if (tmp3_safe_receiver == null)
                    null;
                  else {
                    tmp3_safe_receiver.h68(message.s66_1);
                  }
                } else {
                  if (message instanceof ParseErrorServerMessage()) {
                    println("Cannot parse message: '" + message.t66_1 + "'");
                  } else {
                    if (equals(message, PingServerMessage_instance)) {
                      var tmp4_safe_receiver = this.m67_1.m66();
                      if (tmp4_safe_receiver == null)
                        null;
                      else {
                        // Inline function 'kotlin.let' call
                        send(this.y67_1, tmp4_safe_receiver);
                      }
                    } else {
                      if (!equals(message, PongServerMessage_instance)) {
                        if (!equals(message, ConnectionKeepAliveServerMessage_instance)) {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      u68(data) {
        this.s68(decodeToString(data));
      }
      v68(cause) {
        shutdownInternal(this, cause);
      }
      w68(code, reason) {
        shutdownInternal(this, ApolloWebSocketClosedException().r4d(code == null ? 1001 : code, reason));
      }
      z67(request, listener) {
        var cause = null;
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.q67_1;
        var tmp0_safe_receiver = this.s67_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.mx();
        }
        this.s67_1 = null;
        var tmp;
        switch (this.u67_1.w1_1) {
          case 0:
          case 1:
            this.w67_1.x4(request.s40_1.toString(), listener);
            tmp = this.x67_1.i2(request);
            break;
          case 2:
            this.w67_1.x4(request.s40_1.toString(), listener);
            tmp = launch(this.r67_1, VOID, VOID, SubscribableWebSocket$startOperation$slambda(this, request));
            break;
          case 3:
            cause = DefaultApolloException().n42('Apollo: the WebSocket is shut down', this.v67_1);
            tmp = Unit_instance;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        if (!(cause == null)) {
          listener.i68(ensureNotNull(cause));
        }
      }
      a68(request) {
        var id = request.s40_1.toString();
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.q67_1;
        if (this.w67_1.s4(id)) {
          this.w67_1.y4(id);
          launch(this.r67_1, VOID, VOID, SubscribableWebSocket$stopOperation$slambda(this, request));
          if (this.w67_1.n1()) {
            restartIdleTimeout(this);
          }
        }
      }
    }
    initMetadataForClass($, 'SubscribableWebSocket');
    SubscribableWebSocketClass = $;
  }
  return SubscribableWebSocketClass;
}
var SocketState_AwaitOpen_instance;
var SocketState_AwaitAck_instance;
var SocketState_Connected_instance;
var SocketState_ShutDown_instance;
var SocketState_entriesInitialized;
function SocketState_initEntries() {
  if (SocketState_entriesInitialized)
    return Unit_instance;
  SocketState_entriesInitialized = true;
  SocketState_AwaitOpen_instance = new (SocketState())('AwaitOpen', 0);
  SocketState_AwaitAck_instance = new (SocketState())('AwaitAck', 1);
  SocketState_Connected_instance = new (SocketState())('Connected', 2);
  SocketState_ShutDown_instance = new (SocketState())('ShutDown', 3);
}
var SocketStateClass;
function SocketState() {
  if (SocketStateClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'SocketState');
    SocketStateClass = $;
  }
  return SocketStateClass;
}
function send(_this__u8e3s4, clientMessage) {
  if (clientMessage instanceof TextClientMessage()) {
    _this__u8e3s4.z68(clientMessage.f66_1);
  } else {
    if (clientMessage instanceof DataClientMessage()) {
      _this__u8e3s4.y68(clientMessage.x68_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
}
function SocketState_AwaitOpen_getInstance() {
  SocketState_initEntries();
  return SocketState_AwaitOpen_instance;
}
function SocketState_AwaitAck_getInstance() {
  SocketState_initEntries();
  return SocketState_AwaitAck_instance;
}
function SocketState_Connected_getInstance() {
  SocketState_initEntries();
  return SocketState_Connected_instance;
}
function SocketState_ShutDown_getInstance() {
  SocketState_initEntries();
  return SocketState_ShutDown_instance;
}
//region block: exports
export {
  SubscribableWebSocket as SubscribableWebSockethkxzhdarcovi,
};
//endregion

//# sourceMappingURL=SubscribableWebSocket.mjs.map
